import { render, staticRenderFns } from "./optionItems-editor.vue?vue&type=template&id=18c0dccc&scoped=true"
import script from "./optionItems-editor.vue?vue&type=script&lang=js"
export * from "./optionItems-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c0dccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c0dccc')) {
      api.createRecord('18c0dccc', component.options)
    } else {
      api.reload('18c0dccc', component.options)
    }
    module.hot.accept("./optionItems-editor.vue?vue&type=template&id=18c0dccc&scoped=true", function () {
      api.rerender('18c0dccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/optionItems-editor.vue"
export default component.exports